import createTheme from './createTheme'
import { base } from './mutuamas'

const theme = {
  ...base,
}

theme.components = {
  ...theme.components,
  button: {
    ...theme.components.button,
    fontSize: 'small',
    minHeight: '48px',
    borderWidth: '1px',
    borderRadius: '40px',
  },
  simpleInput: {
    ...theme.components.simpleInput,
    borderRadius: '5px',
    borderWidth: '1px',
    animated: false,
    paddingTop: '8px',
    focusColor: 'black',
  },
  paginatorButton: {
    backgroundColor: 'accent',
    borderColor: 'accent',
    borderRadius: '20px',
    enabledBorderColor: 'transparent',
  },
  table: {
    headerBackgroundColor: 'accent10',
    accent: 'accent',
  },
}

export default createTheme(theme)
